export enum EventsNews {
    EVENTS = 'events',
    NEWS = 'news',
}
